module.exports = __webpack_public_path__ + "img/waistband_width.ad5afa21.png";